export const TITLESREPORT = (centro:any,año:any, periodo: any) => {
    return {
        TENDVEH: `${centro} - TENDENCIA DE CIERRE ${año}`,
        PROPOBJVEH: `${centro} - ${(periodo == 4 ? 'PROPUESTA DE ' : '')}OBJETIVOS ${año + (periodo == 4 ? 1 : 0)}`,
        PROOBJTEND: `${centro} - PROPUESTA DE OBJETIVOS ${año+1}`,
        OBJREAL: `${centro} - OBJETIVOS ${año}`,
        TENDOBJ: `${centro} - TENDENCIA ${año}-CIERRE VS. OBJETIVO ANUAL ${año}`,
        GREVOL: `${centro} - GRAFICO EVOLUTIVO ${año + (periodo == 4 ? 1 : 0)}`,
        GRPRPOBJ: `${centro} - ${(periodo == 4 ? 'PROPUESTA DE ' : '')}OBJETIVOS ${año + (periodo == 4 ? 1 : 0)}`,
        GRTEND: `${centro} - TENDENCIA ${año}`,
        REALOBJ: `${centro} - REAL ${año -1} - 12`,
        GRREAL: `${centro} - GRAFICO REAL ${año -1}`
    }
}